// extracted by mini-css-extract-plugin
export default {"wrapper":"_68b8694b","title":"_2bf1b518","arrowContainer":"_a219e346","arrow":"_1e8459c1","arrowUp":"_784a6e84","message":"_91c55293"};